/**
 * 사천시(gnsc) 프로젝트 전용 부서명("과") 고정 목록
 *
 * 회사 트리 기반으로 선택지를 생성하면, 로그인 사용자의 소속(트리 하위 범위)에 따라
 * "과"가 아닌 "팀"이 선택지로 노출되어 부서명에 팀명이 저장되는 문제가 있었다.
 * (트리는 로그인 사용자의 company_id 를 ancestor 로 하는 하위 트리만 반환하므로,
 *  팀 소속 사용자는 자기 팀만 선택지로 잡힘)
 *
 * 이를 방지하기 위해 검색/작성 페이지 모두 아래 고정 목록을 부서명 선택지로 사용한다.
 * 검색 컴포넌트(SearchSelectCompanyName.vue)와 작성 컴포넌트(workplace-insider/Write.vue)가
 * 동일한 목록을 사용하도록 이 파일을 공용으로 참조한다.
 */
export const GNSC_DEPARTMENT_LIST = [
  "기획예산담당관",
  "공보감사담당관",
  "우주항공과",
  "투자유치산단과",
  "지역경제과",
  "정보통신과",
  "관광정책과",
  "문화예술과",
  "해양수산과",
  "체육진흥과",
  "행정과",
  "민원지적과",
  "세무과",
  "회계과",
  "주민돌봄과",
  "노인장애인과",
  "여성가족과",
  "환경보호과",
  "재난안전과",
  "도로과",
  "교통행정과",
  "녹지공원과",
  "도시과",
  "건축과",
  "건설과",
  "도시재생과",
  "보건위생과",
  "건강증진과",
  "질병관리과",
  "농축산과",
  "미래농업과",
  "기술지원과",
  "평생학습관",
  "환경사업소",
  "상하수도사업소",
  "사천읍",
  "정동면",
  "사남면",
  "용현면",
  "축동면",
  "곤양면",
  "곤명면",
  "서포면",
  "동서동",
  "선구동",
  "동서금동",
  "벌용동",
  "향촌동",
  "남양동",
  "신수출장소",
];

export default GNSC_DEPARTMENT_LIST;
